import { FC } from 'react';
import ArrowIcon from '../../components/svgs/arrowIcon';
import styles from './app-evaluation-overview.module.scss';

type Props = {
  open: boolean;
  /** The row's name, so the button has one. */
  label: string;
};

// A real button puts the row on the Tab order; its click bubbles to the row, which toggles the panel.
const RowChevron: FC<Props> = ({ open, label }) => (
  <button type="button" className={styles.chevronButton} aria-expanded={open} aria-label={label}>
    <ArrowIcon
      color="var(--gray-500)"
      className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`}
    />
  </button>
);

export default RowChevron;
